import PropaneTankOutlinedIcon from "@mui/icons-material/PropaneTankOutlined";
import ArticleOutlinedIcon from "@mui/icons-material/ArticleOutlined";
import SellOutlinedIcon from "@mui/icons-material/SellOutlined";
import FactCheckOutlinedIcon from "@mui/icons-material/FactCheckOutlined";
import GroupOutlinedIcon from "@mui/icons-material/GroupOutlined";
import NoteAddOutlinedIcon from "@mui/icons-material/NoteAddOutlined";
import ReceiptLongOutlinedIcon from "@mui/icons-material/ReceiptLongOutlined";
import PrecisionManufacturingOutlinedIcon from "@mui/icons-material/PrecisionManufacturingOutlined";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import WhatshotOutlinedIcon from "@mui/icons-material/WhatshotOutlined";
import FormatPaintOutlinedIcon from "@mui/icons-material/FormatPaintOutlined";
import RuleOutlinedIcon from "@mui/icons-material/RuleOutlined";
import BugReportOutlinedIcon from "@mui/icons-material/BugReportOutlined";
import ManageAccountsOutlinedIcon from "@mui/icons-material/ManageAccountsOutlined";

// Single source of truth for the sidebar navigation tree. Navbar's
// breadcrumb is derived from this same structure via getBreadcrumbTrail,
// so a route only ever needs a label defined here.
// `text`/`title` values below are i18next translation keys, not display
// strings — Sidebar/Navbar resolve them via t(key) at render time.
export const MENU_ITEMS = [
  {
    title: "sidebar.deaerators",
    icon: PropaneTankOutlinedIcon,
    subItems: [
      { text: "sidebar.newBudget", icon: NoteAddOutlinedIcon, link: "/create-new-budget" },
      { text: "sidebar.budgets", icon: ReceiptLongOutlinedIcon, link: "/budgets" },
      { text: "sidebar.deaeratorsPhc", icon: PrecisionManufacturingOutlinedIcon, link: "/deaerators-phc" }
    ],
  },
  {
    type: "divider",
  },
  {
    title: "sidebar.tablesAndStandards",
    icon: ArticleOutlinedIcon,
    subItems: [
      {
        title: "sidebar.en10028",
        icon: ArticleOutlinedIcon,
        subItems: [
          { icon: DescriptionOutlinedIcon, text: "sidebar.mpMetalSheet", link: "/mp-metal-sheet-table" },
          { icon: DescriptionOutlinedIcon, text: "sidebar.mpSteelElevatedTemp", link: "/mp-steel-elevated-temp-table" },
          { icon: DescriptionOutlinedIcon, text: "sidebar.mpStainSteelTemp", link: "/mp-stain-steel-temp-table" },
          { icon: DescriptionOutlinedIcon, text: "sidebar.mpStainSteel", link: "/mp-stain-steel-table" },
          { icon: DescriptionOutlinedIcon, text: "sidebar.tensileStrengthTemp", link: "/mp-tensile-strength-temp-table" },
        ],
      },
      {
        title: "sidebar.en10216",
        icon: ArticleOutlinedIcon,
        subItems: [
          { icon: DescriptionOutlinedIcon, text: "sidebar.mpTubeElevatedTemp", link: "/mp-tube-elevated-temp-table" },
          { icon: DescriptionOutlinedIcon, text: "sidebar.mpTubeRoomTemp", link: "/mp-tube-room-temp-table" },
        ],
      },
    ],
  },
  {
    type: "divider",
  },
  {
    title: "sidebar.materialsAndPrices",
    icon: SellOutlinedIcon,
    subItems: [
      { text: "sidebar.welding", icon: WhatshotOutlinedIcon, link: "/welding" },
      { text: "sidebar.gestraPrices", icon: ReceiptLongOutlinedIcon, link: "/gestra-price-table" },
      { text: "sidebar.paintSchemes", icon: FormatPaintOutlinedIcon, link: "/paint-scheme-table" },
      { text: "sidebar.spiraxSarcoPrices", icon: ReceiptLongOutlinedIcon, link: "/spirax-sarco-price-table" },
    ],
  },
  {
    type: "divider",
  },
  {
    title: "sidebar.tests",
    icon: FactCheckOutlinedIcon,
    subItems: [
      { text: "sidebar.vacuumBreakerSelection", icon: RuleOutlinedIcon, link: "/vacuum-breaker-select" },
      { text: "sidebar.documentTest", icon: BugReportOutlinedIcon, link: "/document-test" },
    ],
  },
  {
    type: "divider",
  },
  {
    title: "sidebar.users",
    icon: GroupOutlinedIcon,
    subItems: [
      { text: "sidebar.userManagement", icon: ManageAccountsOutlinedIcon, link: "/users" },
    ],
  },
];

// Walks the menu tree to find the group/subgroup/page trail that matches
// a pathname, e.g. "/mp-metal-sheet-table" -> ["sidebar.tablesAndStandards", "sidebar.en10028", "sidebar.mpMetalSheet"].
export function getBreadcrumbTrail(pathname, items = MENU_ITEMS, trail = []) {
  for (const item of items) {
    if (item.type === "divider") continue;

    const label = item.title || item.text;

    if (item.link === pathname) {
      return [...trail, label];
    }

    if (item.subItems) {
      const found = getBreadcrumbTrail(pathname, item.subItems, [...trail, label]);
      if (found) return found;
    }
  }
  return null;
}

function containsActiveRoute(item, pathname) {
  if (item.link === pathname) return true;
  if (item.subItems) return item.subItems.some((sub) => containsActiveRoute(sub, pathname));
  return false;
}

// Returns the path (index chain, e.g. "2-0") of every group that contains
// the active route, so the sidebar can auto-expand the whole active branch
// instead of only highlighting the leaf link.
export function getActiveGroupPaths(items, pathname, prefix = "") {
  const paths = [];
  items.forEach((item, i) => {
    if (item.type === "divider" || !item.subItems) return;
    const path = prefix ? `${prefix}-${i}` : String(i);
    if (containsActiveRoute(item, pathname)) {
      paths.push(path);
      paths.push(...getActiveGroupPaths(item.subItems, pathname, path));
    }
  });
  return paths;
}
